import { keyframes } from "styled-components";

export const dude = keyframes`
from {
  opacity: 0;
  transform: translateX(-100px);
}
to {
  opacity: 1;
  transform: translateX(0);
}
`;

export const middleTop = keyframes`
from {
  transform: translateY(-100px);
  opacity: 0;
}
to {
  transform: translateY(0);
  opacity: 1;
}
`;

export const right = keyframes`
from {
  opacity: 0;
  transform: translateY(-100px);
}
to {
  opacity: 1;
  transform: translateY(0);
}
`;

export const middleBottom = keyframes`
from {
  opacity: 0;
  transform: scale(0);
}
to {
  opacity: 1;
  transform: scale(1);
}
`;
